import React, { useEffect, useState } from 'react';

import MetabaseDashboard from '../components/MetabaseDashboard';

import { getSecurityMetabaseDashboard } from '../../modules/metabase_dashboard.js';

const SecurityLogType = {
  NONE: 'NONE',
  PHI_ACCESS_LOG: 'PHI_ACCESS_LOG',
};

const SecurityDashboard = () => {
  const [dashboardURL, setDashboardURL] = useState<string>('');
  useEffect(() => {
    (async () => {
      const dashboardResponse = await getSecurityMetabaseDashboard(SecurityLogType.PHI_ACCESS_LOG);

      if (dashboardResponse && dashboardResponse.data && dashboardResponse.data.success) {
        setDashboardURL(dashboardResponse.data.dashboard_url);
      }
    })();
  }, []);

  return <MetabaseDashboard dashboardURL={dashboardURL} />;
};

export default SecurityDashboard;
